import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { IndustriesGrid } from "../components/sections";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader
        eyebrow="Industries & sectors"
        title="Where our expertise applies"
        lead="Solution-driven recommendations and compliance support across a diverse range of scientific and industrial domains."
        crumb="Industries"
      />
      <section className="section bg-mist">
        <div className="wrap">
          <Reveal className="sec-head">
            <span className="eyebrow">Sectors we serve</span>
            <h2>Four groups, broad expertise</h2>
            <p>Our multidisciplinary approach spans life sciences, food and agriculture, energy and materials, and the public and specialist sectors.</p>
          </Reveal>
          <IndustriesGrid />
        </div>
      </section>
      <CTABand />
    </div>
  );
}
